import { Link } from 'react-router-dom';
import Typography from 'Components/Typography';

import supplementsHeroDesktop from 'assets/images/home_carousel_4_hero_d.jpg';
import supplementsHeroMobile from 'assets/images/home_carousel_4_hero_m.jpg';
import supplementsHeroTablet from 'assets/images/home_carousel_4_hero_t.jpg';

import welcomeCustomCareImgDesktop from 'assets/images/d-custom-care.jpg';
import welcomeCustomCareImgMobile from 'assets/images/m-custom-care.jpg';
import welcomeCustomCareImgTablet from 'assets/images/t-custom-care.jpg';

import collectionProductImgDesktop from 'assets/images/home/d-product-module-ad.jpg';
import collectionProductImgMobile from 'assets/images/home/mt-product-module.jpg';

import consultationCarouselImg1 from 'assets/images/home/consultation-carousel-1.jpg';
import consultationCarouselImg2 from 'assets/images/home/consultation-carousel-2.jpg';
import consultationCarouselImg3 from 'assets/images/home/consultation-carousel-3.jpg';
import consultationCarouselImg4 from 'assets/images/home/consultation-carousel-4.jpg';
import consultationCarouselImg5 from 'assets/images/home/consultation-carousel-5.jpg';

import bcorpImgDesktop from 'assets/images/home_bcorp_d.jpg';
import bcorpImgMobile from 'assets/images/home_bcorp_mt.jpg';

import customersIllustrationDesktop1 from 'assets/images/routine-natalie.jpg';
import customersIllustrationMobile1 from 'assets/images/m-routine-natalie.jpg';
import customersPicture1 from 'assets/images/natalie.png';
import customersIllustrationDesktop2 from 'assets/images/routine-elena.jpg';
import customersIllustrationMobile2 from 'assets/images/m-routine-elena.jpg';
import customersPicture2 from 'assets/images/elena.png';
import customersIllustrationDesktop3 from 'assets/images/routine-macey.jpg';
import customersIllustrationMobile3 from 'assets/images/m-routine-macey.jpg';
import customersPicture3 from 'assets/images/t.png';

import PressImg1 from 'assets/images/logo_bazaar_home.png';
import PressImg2 from 'assets/images/logo_vogue_home.png';
import PressImg3 from 'assets/images/logo_gq_home.png';
import PressImg4 from 'assets/images/logo_bustle_home.png';

import UgcImgDesktop from 'assets/images/ugc_desktop.jpg';
import UgcImgMobile from 'assets/images/ugc_mobile.jpg';
import UgcImgTablet from 'assets/images/ugc_tab.jpg';

import softFooterImg from 'assets/images/soft_footer_desktop.jpg';

export const dataJsonLd = {
  '@context': 'http://schema.org',
  '@type': 'Organization',
  name: 'Prose',
  url: 'https://prose.com',
  logo: 'https://prose.com/logo.jpg',
  sameAs: ['https://www.facebook.com/prosehair', 'https://www.instagram.com/prose'],
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Brooklyn',
    postalCode: '11249',
    addressRegion: 'NY',
    streetAddress: '10 Grand Street',
  },
};

export const heroContent = () => ({
  backgroundDesktop: supplementsHeroDesktop,
  backgroundMobile: supplementsHeroMobile,
  backgroundTablet: supplementsHeroTablet,
  title: (
    <>
      Transform your hair
      <br />
      with custom care
    </>
  ),
  subtitle: 'Discover your fully personalized routine, from shampoo to supplements',
  cta: {
    component: 'Cta',
  },
});

export const ticker = [
  'paraben free',
  'sulfate free',
  'phthalate free',
  'free of mineral oils',
  'free of GMOs',
  'cruelty-free',
  'carbon neutral',
];

export const welcomeCustomCare = {
  title: 'Welcome to custom haircare',
  primaryTitle: 'We believe that',
  changing: ['beauty is personal', 'care is conscious', 'great hair is for everyone'],
  description: (
    <>
      We know one size fits none. So we re-thought the entire model of mass-beauty to create
      haircare that’s one-in-a-million. It’s a radically custom approach: we create products that
      fit you alone, combining lab innovation, natural ingredients, and proven performance to create
      truly personal care. <br />
      <br />
      For you. For the planet. For all.
    </>
  ),
  cta: 'about us',
  backgroundDesktop: welcomeCustomCareImgDesktop,
  backgroundMobile: welcomeCustomCareImgMobile,
  backgroundTablette: welcomeCustomCareImgTablet,
};

export const collection = {
  title: 'From the collection',
  ctaLabel: 'Explore more',
  products: {
    ad: {
      alt: 'customise product in your routine',
      img: collectionProductImgDesktop,
      mobileImg: collectionProductImgMobile,
      headline: 'Customize every product in your routine',
      cta: 'See the full collection',
    },
  },
};

export const howItWorks = {
  title: 'How it works',
  primaryTitle: 'Think of us as your partner in haircare',
  description: ' We’ll work together to continually improve your hair—and your Prose.',
  instructions: [
    {
      label: (
        <>
          Easy online <br />
          consultation
        </>
      ),
      description:
        'In a few simple questions, we synthesize a myriad of factors around your hair, lifestyle, and preferences to find exactly what your hair needs',
    },
    {
      label: (
        <>
          A fully custom
          <br /> routine
        </>
      ),
      description:
        'We find the products you actually need, then customize each one for a perfect fit. Each one’s made with clean ingredients and bottled fresh to order',
    },
    {
      label: (
        <>
          Review & Refine<sup>®</sup>
          <br />
          your formulas
        </>
      ),
      description: (
        <>
          After receiving each order from Prose, tell us how your custom products perform by rating
          and reviewing each one. Prose will work to tailor your formulas for your next order to
          increase your satisfaction for always-improving results. Prose counts 5-star reviews on a
          per product basis, and includes 5-star reviews from first-time orders and from reviews of
          subsequent orders following a customer’s feedback in the Review & Refine<sup>®</sup>{' '}
          survey. When a customer is repeatedly satisfied, and submits another 5-star review, Prose
          counts that review as well - our goal is to constantly improve and to keep our customers
          happy!
        </>
      ),
    },
  ],
};

export const carousel = {
  text: {
    title: 'Start with our innovative consultation',
    description: (
      <>
        Over 80 factors are synthesized to create your custom formula. We start with micro details
        like hair thickness, condition, and texture, then move to the macro: the weather in your ZIP
        code, your workout routine, stress level, diet, and more. If you’re vegan or gluten-free,
        your Prose can be, too.
        <br />
        <br />
        <br />
        By learning about your hair in its true context, we can give you products that fit—and
        work—better than anything before.
      </>
    ),
  },
  slides: [
    {
      background: consultationCarouselImg1,
      color: 'lilasDark',
      labels: [
        { code: 'for', name: 'Fabienne' },
        { code: '48', name: 'gentle cleanse' },
        { code: '33', name: 'effortless waves' },
        { code: 'Frg', name: 'fragrance-free' },
        { code: 'Geo', name: '65201' },
      ],
    },
    {
      background: consultationCarouselImg2,
      color: 'blue',
      labels: [
        { code: 'for', name: 'huey' },
        { code: '20', name: 'curl define' },
        { code: 'pref', name: 'vegan' },
        { code: 'Frg', name: 'Signature' },
        { code: 'Geo', name: '11249' },
      ],
    },
    {
      background: consultationCarouselImg3,
      color: 'rouge',
      labels: [
        { code: 'for', name: 'Macara' },
        { code: '20', name: 'body & lift' },
        { code: '58', name: 'purify & detox' },
        { code: 'Frg', name: 'Corsica' },
        { code: 'Geo', name: '01945' },
      ],
    },
    {
      background: consultationCarouselImg4,
      color: 'vert',
      labels: [
        { code: 'for', name: 'Alexis' },
        { code: '34', name: 'Curls for days' },
        { code: '32', name: 'Clarify & cleanse' },
        { code: 'Frg', name: 'ispahan' },
        { code: 'Geo', name: '10003' },
      ],
    },
    {
      background: consultationCarouselImg5,
      color: 'blue',
      labels: [
        { code: 'for', name: 'Kay' },
        { code: '77', name: 'Curl shine & define' },
        { code: '61', name: 'Happy hair' },
        { code: 'Frg', name: 'Botanica' },
        { code: 'Geo', name: '11103' },
      ],
    },
  ],
};

export const bcorp = {
  imageDesktop: bcorpImgDesktop,
  imageMobile: bcorpImgMobile,
  title: 'What goes into your Prose is just as good as what you get out of it.',
  description: (
    <>
      <br />
      <Typography markupName="span" paragraph variant="mono2">
        Certified clean ingredients
      </Typography>
      <Typography markupName="span" paragraph variant="p2">
        Free of sulfates, parabens, phlathates—our list of Do Not Fly ingredients continues{' '}
        <Link data-click="ingredients" data-from="block-ingredients" to="/ingredients">
          here
        </Link>
      </Typography>
      <br />
      <Typography markupName="span" paragraph variant="mono2">
        sustainably sourced
      </Typography>
      <Typography markupName="span" paragraph variant="p2">
        We source the best ingredients gathered in the most ethical way. When we find better ways
        forward, we take them.
      </Typography>
      <br />
      <Typography markupName="span" paragraph variant="mono2">
        Conscious impact
      </Typography>
      <Typography markupName="span" paragraph variant="p2">
        As a B Corp-certified company, we keep our impact on your hair, not the planet. We are the
        first and only carbon-neutral custom beauty brand.
      </Typography>
    </>
  ),
  readMoreCta: 'Read more',
};

export const customers = {
  title: 'From real custom-ers',
  customers: [
    {
      quote:
        '“I really love the way my hair feels since using Prose! It’s healthier and softer and I really love how it smells!”',
      name: 'Nathalie',
      description: 'is a curly girl in Maine. Her routine includes:',
      usedProducts: 'The Core Trio — Curl Cream',
      picture: customersPicture1,
      routineIllustration: customersIllustrationDesktop1,
      routineIllustrationMobile: customersIllustrationMobile1,
    },
    {
      quote:
        '“This is the best hair care I’ve ever had in my life. Game changer. Will never look back at other shampoo!”',
      name: 'Elena',
      description: 'is a vegan in California. Her routine includes:',
      usedProducts: 'Shampoo — Conditioner',
      picture: customersPicture2,
      routineIllustration: customersIllustrationDesktop2,
      routineIllustrationMobile: customersIllustrationMobile2,
    },
    {
      quote:
        '“I love all the products that I have tried. They all have contributed to great volume, shine and curl.”',
      name: 'T',
      description: 'is a fitness buff outside Niagara Falls. Her fuss-free routine includes:',
      usedProducts: 'The Core Trio — Dry Shampoo.',
      picture: customersPicture3,
      routineIllustration: customersIllustrationDesktop3,
      routineIllustrationMobile: customersIllustrationMobile3,
    },
  ],
  ctaLabel: 'read more reviews',
};

export const press = {
  title: 'in the press',
  quotes: [
    {
      quote: '“Prose is revolutionizing hair care with custom, made-to-order formulas…”',
      logo: PressImg1,
      alt: 'bazaar logo',
    },
    {
      quote: '“Taking tailored treatments to the next level...”',
      logo: PressImg2,
      alt: 'vogue logo',
    },
    {
      quote: '“Winner of Bespoke Styler award, GQ Grooming Awards 2019”',
      logo: PressImg3,
      alt: 'gq logo',
    },
    {
      quote: "“Prose's custom dry shampoo is certainly a product to test for yourself”",
      logo: PressImg4,
      alt: 'bustle logo',
    },
  ],
};

export const ugc = {
  title: 'Show us what great hair looks like for you',
  secondaryTitle: '#prosehair',
  image: UgcImgDesktop,
  imageT: UgcImgMobile,
  imageM: UgcImgTablet,
};

export const softFooter = {
  title: 'Luxury comes in one size. Yours.',
  image: softFooterImg,
};
